export const getContactDetails = (contactData) => [
  { label: "Contact Number", value: contactData?.phone },
  { label: "Email ID", value: contactData?.email },
  { label: "Whatsapp Number", value: contactData?.whatsapp_number },
];
